import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { archiveBoard } from "../../../../../../services/apiBoards";
import { objectToFormData } from "../../../../../../utils";
import { changeExpand } from "../../../../../../redux/boardListSlice";
import { useCustomSearchParams } from "../../../../../../hooks/useCustomSearchParams";
import useToastPromise from "../../../../../../hooks/useToast";
import { normalizeBoardHeaderData } from "../../hooks/boardHeaderUtils";

export function useArchiveState(boardId) {
  const { id: boardKey } = useParams();
  const queryClient = useQueryClient();
  const [anchorEl, setAnchorEl] = useState(null);
  const [archiveDialog, setArchiveDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openCSV, setOpenCSV] = useState(false);
  const [openMergeBoard, setOpenMergeBoard] = useState(false);
  const [openManageFields, setOpenManageFields] = useState(false);
  const [openBoardNotifications, setOpenBoardNotifications] = useState(false);
  const [, setParamsWorklogs] = useCustomSearchParams("worklogs");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showToastPromise } = useToastPromise();

  const currentBoard = normalizeBoardHeaderData(
    queryClient.getQueryData(["boardName", boardId])
  );
  const isArchive = currentBoard?.is_archive;

  const { mutate: archiveMutate } = useMutation({
    mutationFn: async (data) => showToastPromise(archiveBoard, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["boards"],
      });
      dispatch(changeExpand(isArchive ? "panel1" : "panel2"));
      queryClient.invalidateQueries({
        queryKey: ["boardName", boardId],
      });
      setLoading(false);
      setArchiveDialog(false);
    },
    onError: (error) => {
      console.error("Error Delete Attachments", error);
      setLoading(false);
      setArchiveDialog(false);
    },
  });

  const callback = () => {
    const data = objectToFormData({
      is_archive: !isArchive,
      board_id: boardId,
    });

    setLoading(true);
    archiveMutate({ id: boardId, data });
  };

  return {
    anchorEl,
    archiveDialog,
    callback,
    currentBoard,
    handleCSV: () => setOpenCSV(true),
    handleClick: (event) => setAnchorEl(event.currentTarget),
    handleClose: () => setAnchorEl(null),
    handleCloseDialog: () => setArchiveDialog(false),
    handleFeedClick: () => navigate(`/feeds/${boardKey}`),
    handleSetupBoardNotifications: () => setOpenBoardNotifications(true),
    handleManageFields: () => setOpenManageFields(true),
    handleMergeBoard: () => setOpenMergeBoard(true),
    handleWorklogsClick: () => setParamsWorklogs("worklogs", "true"),
    isArchive,
    loading,
    open: Boolean(anchorEl),
    openBoardNotifications,
    openCSV,
    openManageFields,
    openMergeBoard,
    setArchiveDialog,
    setOpenBoardNotifications,
    setOpenCSV,
    setOpenManageFields,
    setOpenMergeBoard,
  };
}
